export default "__VITE_ASSET__B4zksStE__"